import en from './languages/en';
import de from './languages/de';


const config: CVT.Config = {
  projectName: '4IE Projects',
  featureFlags: {
    googleSSO: true,
    microsoftSSO: false,
    translations: false,
    notifications: false,
    darkMode: false,
    signup: false,
  },
  theme: {
    defaultMode: 'light',
    drawerWidth: 240,
    disableRipple: true,
    elevation: 0,
  },
  language: {
    dictionaries: {
      en,
      de,
    },
    languageLabelMap: {
      en: 'English',
      de: 'Deutsche',
    },
    supportedLanguages: ['en', 'de'],
    defaultLanguage: 'en',
    defaultDictionary: en,
  },
  // Baseline for Homeowner / Partner / logged-out users: no access to any
  // current section. Admins are granted the full set at runtime in UserContext.
  defaultPermissions: {
    users: {
      list: false,
      view: false,
      create: false,
      edit: false,
      delete: false,
      invite: false,
    },
    companies: {
      list: false,
      view: false,
      create: false,
      edit: false,
      delete: false,
    },
    projects: {
      list: false,
      view: false,
      create: false,
      edit: false,
      delete: false,
    },
    leads: {
      list: false,
      view: false,
      create: false,
      edit: false,
      delete: false,
    },
    hub: {
      view: false,
    },
  },
  dialogs: [
    'inviteTeamMember',
    'createProject',
    'addSubstage',
    'addNote',
    'addSubstageTask',
    'editSubstageTask',
    'uploadProjectDocuments',
    'editProjectDocument',
    'uploadProjectInvoices',
    'editChecklist',
    'editChecklistAttachment',
    'editSubstage',
    'addMeeting',
    'createLead',
    'leadDocuments',
    'leadNote',
    'leadLostReason',
  ],
};

export default config;
